import { useEffect, useRef, useState } from 'react';

interface InstagramPost {
  id: number;
  image: string;
  caption: string;
  link: string;
  likes: string;
}

const posts: InstagramPost[] = [
  {
    id: 1,
    image: 'https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/53c9e2b00aa97609ba8a197e133f4431.png',
    caption: 'Qual a verdadeira história por trás do medo de fazer reposição hormonal?',
    link: 'https://www.instagram.com/p/DHtOUCmRuQr/',
    likes: '2.4k',
  },
  {
    id: 2,
    image: 'https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/c9b14cc3786d7259ea024a1105ef4522.png',
    caption: 'Comece em dezembro. Comece no domingo. Comece aos 40. Comece às 18h. Comece no dia 31. Comece tarde. Comece.',
    link: 'https://www.instagram.com/p/DDFJVmAxp84/',
    likes: '1.8k',
  },
  {
    id: 3,
    image: 'https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/73c2ed4a77add8abd8d8ea3ea5829a95.png',
    caption: 'Dá sim pra viver com equilíbrio, energia e bem estar.',
    link: 'https://www.instagram.com/p/DHYxXVTMqy_/',
    likes: '3.1k',
  },
  {
    id: 4,
    image: 'https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/6bcda3b51f57ca7bc7f214b6e7f3a8df.png',
    caption: 'Paciente com lipedema não pode usar Mounjaro?',
    link: 'https://www.instagram.com/p/C_yCZZXu_07/',
    likes: '643',
  },
];

export default function InstagramSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      id="instagram"
      className="relative py-20 md:py-28 overflow-hidden"
      style={{ backgroundColor: '#F8F7F5' }}
    >
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 md:px-12">
        {/* Header */}
        <div
          className="text-center mb-14"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 0.8s ease-out',
          }}
        >
          <p
            className="text-sm tracking-[0.15em] mb-4"
            style={{
              fontFamily: 'var(--font-body)',
              color: '#C8A96A',
              fontWeight: 500,
            }}
          >
            INSTAGRAM
          </p>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl mb-5"
            style={{
              fontFamily: 'var(--font-heading)',
              color: '#2E2E2E',
              fontWeight: 500,
              lineHeight: 1.2,
            }}
          >
            Acompanhe no Instagram
          </h2>
          <p
            className="text-sm md:text-base max-w-[480px] mx-auto"
            style={{
              fontFamily: 'var(--font-body)',
              color: '#6B6560',
              fontWeight: 300,
              lineHeight: 1.7,
            }}
          >
            Conteúdo exclusivo sobre saúde, bem-estar e transformação. Clique em qualquer publicação para ver no Instagram.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
          {posts.map((post, i) => (
            <a
              key={post.id}
              href={post.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative block overflow-hidden rounded-[16px] md:rounded-[20px] cursor-pointer"
              style={{
                aspectRatio: '1 / 1',
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(30px)',
                transition: `all 0.7s ease-out ${i * 120}ms`,
              }}
              onMouseEnter={() => setHoveredId(post.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              {/* Image */}
              <img
                src={post.image}
                alt={post.caption}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />

              {/* Hover overlay */}
              <div
                className="absolute inset-0 flex flex-col items-center justify-center p-4 text-center transition-all duration-500"
                style={{
                  backgroundColor: 'rgba(14, 20, 18, 0.65)',
                  opacity: hoveredId === post.id ? 1 : 0,
                }}
              >
                <i className="ri-instagram-line text-2xl md:text-3xl mb-3" style={{ color: '#F8F7F5' }} />
                <p
                  className="text-xs md:text-sm leading-relaxed mb-3 line-clamp-3"
                  style={{
                    fontFamily: 'var(--font-body)',
                    color: '#F8F7F5',
                    fontWeight: 400,
                  }}
                >
                  {post.caption}
                </p>
                <div className="flex items-center gap-1.5">
                  <i className="ri-heart-fill text-xs" style={{ color: '#C8A96A' }} />
                  <span
                    className="text-xs"
                    style={{
                      fontFamily: 'var(--font-body)',
                      color: 'rgba(248, 247, 245, 0.7)',
                      fontWeight: 400,
                    }}
                  >
                    {post.likes}
                  </span>
                </div>
              </div>

              {/* Subtle border */}
              <div
                className="absolute inset-0 rounded-[16px] md:rounded-[20px] pointer-events-none"
                style={{
                  border: '1px solid rgba(0, 0, 0, 0.06)',
                }}
              />
            </a>
          ))}
        </div>

        {/* Follow button */}
        <div
          className="text-center mt-12"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(10px)',
            transition: 'all 0.8s ease-out 0.5s',
          }}
        >
          <a
            href="https://www.instagram.com/dramelissaciriaco"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2.5 px-8 py-3.5 rounded-full text-sm font-medium tracking-[0.04em] whitespace-nowrap cursor-pointer transition-all duration-300"
            style={{
              fontFamily: 'var(--font-body)',
              backgroundColor: 'rgba(14, 20, 18, 0.06)',
              color: '#2E2E2E',
              border: '1px solid rgba(0, 0, 0, 0.08)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(14, 20, 18, 0.1)';
              e.currentTarget.style.borderColor = 'rgba(0, 0, 0, 0.15)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(14, 20, 18, 0.06)';
              e.currentTarget.style.borderColor = 'rgba(0, 0, 0, 0.08)';
            }}
          >
            <i className="ri-instagram-line text-lg" />
            @dramelissaciriaco
          </a>
        </div>
      </div>
    </section>
  );
}